import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SignUpFiveGService } from '../shared/signup-fiveg.service';
import { StepIndicatorService, BreadCrumbService, PageLoaderService, GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  providers: [SignUpFiveGService]
})
export class ReviewFivegComponent implements OnInit {

  enrolledData: any;
  @ViewChild('confirm') confirm : ElementRef;
  isDisabled: boolean = true;
  reviewAccounts: any;
  showErrors = false;
  gridOptions: GridOptionsModel;

  constructor(private pageLoaderService: PageLoaderService ,private router: Router,private breadCrumbService: BreadCrumbService, private utilityService: UtilityService,private signupFivegService: SignUpFiveGService, private stepIndicatorService: StepIndicatorService, private route: ActivatedRoute) {
    const signUpData = this.signupFivegService.getSignupData();
    if(!signUpData) {
       this.router.navigate(['/fiveg/enrollment']);
    }
   }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    // this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device enrollment', routerLink: '/fiveg/enrollment/selectaccounts' });
    this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicatorService.setVisibility(true);
    this.showErrors = false;
    this.reviewAccounts = this.route.snapshot.data.pageData.fivegenrollmentreview;
    this.enrolledData = JSON.parse(sessionStorage.getItem('newFivegEnrollment'));
    let fansList = Object.keys(this.enrolledData.fanList);
    fansList.sort();
    this.reviewAccounts.grid.gridData = fansList;
    this.gridOptions = this.reviewAccounts.grid;
    this.gridOptions.gridData = this.reviewAccounts.grid.gridData;
    this.gridOptions.Paginations.totalRecords = this.gridOptions.gridData.length;
    this.isDisabled = true;
  }

  enableSubmit() {
    if(this.confirm.nativeElement.checked == true) {
        this.isDisabled = false;
    }
    else {
        this.isDisabled = true;
    }
}

  continueToNext() {
    let data = sessionStorage.getItem('newFivegEnrollment');
    this.pageLoaderService.setPageLoaderStatus(false);
    this.signupFivegService.sendEmail(data)
    .subscribe(respobj => {
      this.pageLoaderService.setPageLoaderStatus(true);
            this.showErrors = false;
            this.router.navigate(['/fiveg/enrollment/confirm']);
    },
    error => {
      this.pageLoaderService.setPageLoaderStatus(true);
      this.handleError(error);
    })
  }

  handleError(error) {
    if (error) {
      this.utilityService.loadFocusOnTop();
      this.showErrors = true;
    }
  }


}
